(function() {
	'use strict';
	angular.module('app.core')
		.service('formatterService', formatterService);
	
	function formatterService($filter) {
		return {
			formatCurrency: formatCurrency,
			formatPercent: formatPercent,
			formatDecimal: formatDecimal,
			numberOfDecimals: numberOfDecimals
		};
		
		function formatCurrency(number, decimals, symbol, showNegative) {
			var isNegative = number < 0;
			if (isNegative) number = number * -1;
			var numDecimals = typeof decimals !== 'undefined' && decimals == 0 ? 0 : numberOfDecimals(number, decimals, false);
			if (showNegative && isNegative) {
				return '-' + $filter('currency')(number, typeof symbol === 'undefined' || symbol == ''? globalConfig.browser.currencySymbol : symbol, numDecimals);
			} else {
				return $filter('currency')(number, typeof symbol === 'undefined' || symbol == ''? globalConfig.browser.currencySymbol : symbol, numDecimals);
			}
		}
		
		function formatPercent(number, decimals) {
			return $filter('number')(number * 100, decimals) + '%';
		}
		
		function formatDecimal(number, defaultDecimals, keepAllDecimals, keepWhole) {
			var numDecimals = numberOfDecimals(number, defaultDecimals, keepAllDecimals, keepWhole);
			return $filter('number')(number, numDecimals);
		}
		
		function numberOfDecimals(val, defaultDec, keepAllDecimals, keepWhole) {
			if(keepWhole && Number.isInteger(val)) {
				return 0;
			}

			var decimals = defaultDec;
			if (!decimals && decimals !== 0)
				decimals = 2;
			if (keepAllDecimals) {
				var valTmp = '' + val;
				var valSplit = valTmp.split('.');
				if (valSplit && valSplit.length == 2) {
					valTmp = valSplit[1].replace(/0+$/, '');
					return valTmp.length;
				} else {
					return 0;
				}
			}
			if (val == 0) {
				decimals = 0;
			} else if (val < 0.0000001 && val > -0.0000001 && decimals < 9) {
				decimals = 9;
			} else if (val < 0.000001 && val > -0.000001 && decimals < 8) {
				decimals = 8;
			} else if (val < 0.00001 && val > -0.00001 && decimals < 7) {
				decimals = 7;
			} else if (val < 0.0001 && val > -0.0001 && decimals < 6) {
				decimals = 6;
			} else if (val < 0.001 && val > -0.001 && decimals < 5) {
				decimals = 5;
			} else if (val < 0.01 && val > -0.01 && decimals < 4) {
				decimals = 4;
			} else if (val < 0.1 && val > -0.1 && decimals < 3) {
				decimals = 3;
			} else if (val < 1 && val > -1 && decimals < 2) {
				decimals = 2;
			}

			if (val > 10 || val < -10) {
				if (!defaultDec) {
					decimals = 0;
				} else {
					decimals = defaultDec;
				}
			}
			return decimals;
		}
	}
})();
